// Copyright (C) 2017-2022 Smart code 203358507

const AddonDetails = require('./AddonDetails');

module.exports = AddonDetails;
